import React from "react";
import Footer from "../Footer.js";
import './uniqueclasses.css'
import ReactGA from 'react-ga4';

import alapallapot from './Media/alapallapotfelmeres.jpg'
import balance from './Media/balance teszt.jpg'
import komplex from './Media/komplex állapotfelmérés.jpg'


ReactGA.send({ hitType: "pageview", page: "/allapotfelmeresek", title: "Allapotfelmeresek" });

function Allapotfelmeresek() {
  


  return (
    <div>
            
    <div className="book-main-container"> 

<div className="unique-class-title-lia allapotpic">
<div className="unique-class-title-left">

<h1>Állapotfelmérések</h1>

<div className="personal-data-lia">
        <a href = "mailto:info@liafit.hu">info@liafit.hu</a>
        <a href="tel:+36703836041">+36 70 383 6041</a>
    </div>
</div>
</div>


<div className="container">
  <div>






<div className="colorandwrap wrap-alap">
<section className="felmeres-box-alap">
  <h1 className="felmeres-cim">Alap állapotfelmérés</h1>
<p className="rovid-bevezeto">
Az egyéni foglalkozások első alkalma mindig egy alap állapotfelméréssel kezdődik. Ez segít feltérképezni
az egészségi és mozgásszervi állapotodat, a céljaidat, valamint az esetleges problémákat, mint például:
</p>
<div className="felmeres-content">
<ul className="felsorolas">
<li>tartáshibák</li>
<li>izom-egyensúlytalanságok</li>
<li>mozgásbeszűkülések</li>
<li>sérülések</li>
</ul>
<h2 className="megjegyzes">
Szükség esetén további orvosi vizsgálatokat és/vagy komplexebb tesztek elvégzését javasoljuk.
</h2>
</div>
<div className="felmeres-price">
  <p>Ára: 13.000 Ft / fő – 1 órás</p>
</div>
</section>
<img src={alapallapot} alt="Alap állapotfelmérés" className="felmeres-img" />
</div>

<div className="colorandwrap wrap-komplex">
<section className="felmeres-box-komplex">
  <h1 className="felmeres-cim">Komplex állapotfelmérés</h1>
<p className="rovid-bevezeto">
Ha részletesebb képet szeretnél kapni a fizikai állapotodról, ez a csomag
további vizsgálatokat tartalmaz:
</p>
<div className="felmeres-content">
<ul className="felsorolas">
<li>Mindent az alap állapotfelmérésből</li>
<li>Szubjektív fájdalom teszt – Segít azonosítani a problémás területeket.</li>
<li>Testösszetétel-elemzés – Megmutatja a testzsírszázalékot, izomtömeg-arányt, zsigeri zsírt és egyéb
fontos adatokat.</li>
<li>Erő és mozgékonyság tesztelése – Fogáserő és hajlékonysági mérések, amelyek megmutatják a fizikai állapotodat.</li>
<li>Az eredményeket és azok kiértékelését a következő egyéni foglalkozásunkig emailben továbbítjuk a
számodra.</li>
</ul>

</div>
<div className="felmeres-price">
  <p>Ára: 20.000 Ft / fő – kb. 1 órás</p>
</div>
</section>
<img src={komplex} alt="Komplex állapotfelmérés" className="felmeres-img" />
</div>

<div className="colorandwrap wrap-balance">
<section className="felmeres-box-balance">
  <h1 className="felmeres-cim">BalanceTest</h1>
<p className="rovid-bevezeto">
Az alábbi betegségek, tűnetek esetén javasolt:
</p>
<div className="felmeres-content">
<ul className="felsorolas">
<li>gyulladások, allergiák, autoimmunbetegségek, ízületi fájdalmak, ízületi kopások, ételintolerancia
(glutén, laktóz, stb…), emésztési problémák, sportteljesítmény javítás, alultápláltság, gyakori
megfázások, betegségek esetén, súlyproblémák, stb…</li>
<li>Egy speciális vércseppanalízis, amely a szervezeted zsírsav-egyensúlyát méri fel, mely tükrözi az
elmúlt 120 nap étrendjét. Ez a profil szoros összefüggésben van az egészségi állapottal, általa
egyértelműen tudunk következtetni a hibás és helyes étkezési szokásokra.</li>
<li>A teszt megérkezését követően (általában 3 hét) segítek az eredmények kiértékelésében és
megbeszéljük a szükséges életmódbeli változtatásokat a célok elérése érdekében.</li>

</ul>

</div>
<div className="felmeres-price">
  <p>Ára: 50.000 Ft / fő – teszt elvégzése kb. 15 perc, eredmények kiértékelése kb. 30 perc</p>
</div>
</section>
<img src={balance} alt="BalanceTest" className="felmeres-img" />
</div>


<div className="colorandwrap wrap-kontroll">
<section className="felmeres-box-kontroll">
  <h1 className="felmeres-cim">Kontroll</h1>
<p className="rovid-bevezeto">
Az egyéni vagy csoportos foglalkozások intenzitása, a javaslataink betartásának következetességétől függően
kontroll teszteléseket javaslunk.
</p>

<h2 className="megjegyzes">
Kontroll teszt min. 120 nap max fél év múlva újra javasolt.
</h2>


<div className="felmeres-price">
  <p>Ára: 15.000 Ft / fő</p>
</div>
</section>
</div>
</div>      
</div>


<p className="allapot-utoirat">Az állapotfelméréseket Lia és Martin végzik.</p>


</div>
<Footer />
</div>
  );
}

export default Allapotfelmeresek;